import MainNavBar2 from "../../components/Main_Interface/MainNavBar/MainNavBar2";
import MainFooter from "../../components/Main_Interface/Footer/Footer";
import MainAboutUsMap from "../../components/Main_Interface/Map/aboutUsMap";
import MainFloatingButton from "../../components/Main_Interface/Footer/MainFloatingButton";
import Iframe from 'react-iframe'

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { useState, useEffect } from "react";

export default function AboutUs() {

    useEffect(() => {
        localStorage.setItem("form_project_detail", false)
        localStorage.removeItem("pageCount");
        localStorage.removeItem("pageValue");
        localStorage.removeItem("offset");
        localStorage.removeItem("ItemOffset");
        localStorage.removeItem("projectArea");
        localStorage.removeItem("projectBuildingStyle");
        localStorage.removeItem("projectBuildingType");
        localStorage.removeItem("hasFeatured") ;
        localStorage.removeItem("projectHouseName");
    }, []);

    return (
        <>
            <MainNavBar2 currentPage={"aboutUs"}></MainNavBar2>
            <div className="relative bg-white mt-16">
                <div className="absolute inset-0">
                    <div className="absolute inset-y-0 left-0 w-1/2" />
                </div>
                <AnimationOnScroll animateIn="animate__bounceInUp" animateOnce={true}>
                <div className="relative max-w-7xl mx-auto lg:grid lg:grid-cols-5">
                    <div className=" py-16 px-4 sm:px-6 lg:col-span-2 lg:px-8 lg:py-24 xl:pr-12">
                        <div className="max-w-lg mx-auto">
                            <h2 className="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">聯絡我們</h2>
                            <p className="mt-3 text-lg leading-6 text-gray-500">
                                歡迎查詢報價及預約
                            </p>
                            {/* <p className="mt-3 text-lg leading-6 text-gray-500">
                                消防,清拆,搭棚,驗窗,水電,油漆,泥水,傢俬,代辦飲食牌照,酒店牌照等 ,專業人事提供大家選擇
                            </p> */}
                            <dl className="mt-8 text-base text-gray-500">
                                <div>
                                    <dt className="sr-only">Chinese Address</dt>
                                    <dd>
                                        <p>大角咀通州街111號 雲之端 17樓 5室 </p>
                                    </dd>
                                </div>
                                <div>
                                    <dt className="sr-only">English Address</dt>
                                    <dd>
                                        <p>Unit 05, 17/F, The Cloud,</p>
                                        <p>No.111 Tung Chau Street,</p>
                                        <p>Tai Kok Tsui, Kowloon</p>
                                    </dd>
                                </div>
                                <div className="mt-6">
                                    <dt className="sr-only">Whatsapp/Signal</dt>
                                    <dd className="flex">
                                        <svg className="flex-shrink-0 h-6 w-6 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 18">
                                            <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                                        </svg>
                                        <span className="ml-3">9237 4820</span>
                                    </dd>
                                </div>
                                <div className="mt-3">
                                    <dt className="sr-only">Email</dt>
                                    <dd className="flex">
                                        <svg className="flex-shrink-0 h-6 w-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                                        <span className="ml-3"><a href="mailto:fookchonglivingengineering@gmail.com">fookchonglivingengineering@gmail.com</a></span>
                                    </dd>
                                </div>
                            </dl>

                        </div>
                    </div>
                    <div className="bg-white py-16 px-4 sm:px-6 lg:col-span-3 lg:py-24 lg:px-8 xl:pl-12">
                        <div className="max-w-lg mx-auto lg:max-w-none">
                            <Iframe
                                url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3690.779005946498!2d114.16080735088072!3d22.324196147595483!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340401dcdf988465%3A0xb4fc3082e6193d65!2z6Zuy5LmL56uv!5e0!3m2!1szh-TW!2shk!4v1671111683923!5m2!1szh-TW!2shk"
                                allowfullscreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="h-96 w-full">

                            </Iframe>
                        </div>
                    </div>
                </div>
                </AnimationOnScroll>
            </div>
            <MainFloatingButton></MainFloatingButton>
            <MainFooter></MainFooter>
        </>
    );
}